export default {
  number: {
    id: 'gift_cards_results_number',
    defaultMessage: 'Number',
  },
  date: {
    id: 'gift_cards_results_date',
    defaultMessage: 'Date',
  },
  billingAddress: {
    id: 'gift_cards_results_billing_address',
    defaultMessage: 'Billing address',
  },
  payment: {
    id: 'gift_cards_results_payment',
    defaultMessage: 'Payment',
  },
  creditCard: {
    id: 'gift_cards_results_credit_card',
    defaultMessage: 'Credit or debit card',
  },
}
